/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for NotificationCtl controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_VERSUSCLIENT, CLIENT_CONTEXT_TOKEN_VERSUSCLIENT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions } from "../models";

@Injectable({ providedIn: "root" })
export class NotificationCtlService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_VERSUSCLIENT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_VERSUSCLIENT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'VersusClient');
    }

    loadNotifyFile(file: Blob, object: string, message: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    loadNotifyFile(file: Blob, object: string, message: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    loadNotifyFile(file: Blob, object: string, message: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    loadNotifyFile(file: Blob, object: string, message: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/notifications`;

        let params = new HttpParams();
        if (object != null) {
            params = HttpParamsBuilder.addToHttpParams(params, object, 'object');
        }
        if (message != null) {
            params = HttpParamsBuilder.addToHttpParams(params, message, 'message');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Remove Content-Type for multipart (browser will set it with boundary)
        headers = headers.delete('Content-Type');

        const formData = new FormData();
        if (file !== undefined) {
            formData.append('file', file);
        }

        return this.httpClient.request('post', url, {
            body: formData,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
